// extracted by mini-css-extract-plugin
export default {"root":"languageSelector_root__7fLnc","trigger":"languageSelector_trigger__Sx12h","menu":"languageSelector_menu__3vGq6","chevron":"languageSelector_chevron__i0Bjv"};